import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const deportes = [
  { 
    nombre: 'Básquet Masculino', 
    descripcion: 'Compite en Liga Nacional, Basketball Champions League Americas, y torneos locales.'
  },
  { 
    nombre: 'Básquet Femenino', 
    descripcion: 'Compite en La Liga Femenina y torneos locales.'
  },
  { 
    nombre: 'Vóley', 
    descripcion: 'Equipo federado con participación nacional y torneos locales.'
  },
  { 
    nombre: 'Patín', 
    descripcion: 'Escuela de patín artístico para todas las edades, participa en torneos provinciales, locales y nacionales.'
  },
  { 
    nombre: 'Cestoball', 
    descripcion: 'Participación federada en torneos provinciales, locales y nacionales.'
  },
];

const Deportes = () => {
  return (
    <>
      <main className="bg-gray-100 text-[#202C5A] min-h-screen py-10 px-4">
        <h1 className="text-3xl font-bold text-center mb-10 uppercase">
           Otros Deportes
        </h1>

        <div className="grid md:grid-cols-3 gap-6">
          {deportes.map((d, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-xl shadow-md p-4 flex flex-col"
            >
              <h2 className="text-xl font-bold mb-2">{d.nombre}</h2>
              <p className="text-sm text-gray-700">{d.descripcion}</p>
            </div>
          ))}
        </div>

        {/* Llamado a la acción final */}
        <div className="mt-12 text-center">
          <p className="text-lg font-semibold mb-2">¿Querés conocer más?</p>
          <a
            href="https://www.instagram.com/aquimsa_deportes/following/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-[#FF69B4] text-white px-6 py-2 rounded-full hover:bg-pink-500 transition"
          >
            Seguinos en Instagram: @aquimsa_deportes
          </a>
        </div>
      </main>
    </>
  );
};

export default Deportes;
